export const areaOrder = [
  "北海道",
  "東北",
  "北関東",
  "首都圏",
  "甲信越",
  "北陸",
  "東海",
  "近畿",
  "山陽・山陰",
  "四国",
  "九州",
  "沖縄"
];
